module.exports = __webpack_public_path__ + "img/9.38f533d1.webp";